import React from 'react'

const NewCancel = () => {
  return (
    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.0962 1.09627L1.09619 13.0963M13.0962 13.0962L1.09619 1.09619" stroke="#28303F" strokeWidth="2.12132" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

export default NewCancel